// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"59":"d96aac1b","129":"50afad8f"}[chunkId] + ".css";
};